export const APP_ID = Symbol('APP_ID');
